import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiRequest, errorFormatHandler } from "../../helpers/apiHelper";
import { TransportHistoryFilters } from "../interfaces/transport.interface";

export const fetchDrivers = createAsyncThunk(
  "/transport/fetchDrivers",
  async (
    params: {
      perPage: number;
      page?: number;
      nume?: string;
      prenume?: string;
      type?: number;
      nrauto?: string;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await apiRequest(`/displaySoferi`, "POST", {
        // user roles: 10,11,12,20 for delivers, internode driver, substitute(rezerva), nod manager
        user_role: [10, 11, 12, 20],
        ...params,
      });
      return data;
    } catch (err: any) {
      console.warn("/transport/fetchDrivers", err);
      return rejectWithValue(errorFormatHandler(err));
    }
  },
);

export const fetchUniqueDrivers = createAsyncThunk(
  "/transport/fetchUniqueDrivers",
  async (
    params: {
      perPage: number;
      page?: number;
      routeType?: "local" | "intranod" | "compusa";
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await apiRequest(`/displayUniqueDrivers`, "POST", {
        ...params,
      });
      return data;
    } catch (err: any) {
      console.warn("/transport/fetchDrivers", err);
      return rejectWithValue(errorFormatHandler(err));
    }
  },
);

export const fetchRoutesNomenclatures = createAsyncThunk(
  "/transport/fetchRoutesNomenclatures",
  async (params: { perPage: number }, { rejectWithValue }) => {
    try {
      const { data } = await apiRequest(`/nomRute`, "GET", params);
      return data;
    } catch (err: any) {
      console.warn("/transport/fetchRoutesNomenclatures", err);
      return rejectWithValue(errorFormatHandler(err));
    }
  },
);

export const fetchIntranodesNomenclatures = createAsyncThunk(
  "/transport/fetchIntranodesNomenclatures",
  async (params: { perPage: number }, { rejectWithValue }) => {
    try {
      const { data } = await apiRequest(`/nomRuteIntranod`, "GET", params);
      return data;
    } catch (err: any) {
      console.warn("/transport/fetchIntranodesNomenclatures", err);
      return rejectWithValue(errorFormatHandler(err));
    }
  },
);

export const fetchAssignDriverToRoute = createAsyncThunk(
  "/transport/fetchAssignDriverToRoute",
  async (
    params: {
      id_user?: string | number | null;
      id_ruta?: string | number;
      id_ruta_intranod?: string | number;
      sofer_data_start?: string;
      sofer_data_stop?: string;
      id_auto?: string | number;
      id_nod_start?: string | number;
      id_nod_stop?: string | number;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await apiRequest(`/alocaSofer`, "POST", params);
      return data;
    } catch (err: any) {
      console.warn("/transport/fetchAssignDriverToRoute", err);
      return rejectWithValue(errorFormatHandler(err));
    }
  },
);

export const fetchAssignDriverToNewRoute = createAsyncThunk(
  "/transport/fetchAssignDriverToNewRoute",
  async (params: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await apiRequest(
        `/assignDriverToNewRoute`,
        "POST",
        params,
      );
      return data;
    } catch (err: any) {
      console.warn("/transport/fetchAssignDriverToNewRoute", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const fetchDeactivateOrActivateRoute = createAsyncThunk(
  "/transport/fetchDeactivateOrActivateRoute",
  async (
    params: {
      id_sofer_rute: string | number;
      activ: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await apiRequest(
        `/deactivateOrActivateRoute`,
        "POST",
        params,
      );
      dispatch(fetchDrivers({ perPage: 999, page: 1 }));
      return data;
    } catch (err: any) {
      console.warn("/transport/fetchDeactivateOrActivateRoute", err);
      return rejectWithValue(errorFormatHandler(err));
    }
  },
);

export const fetchActiveTransports = createAsyncThunk(
  "/transport/fetchActiveTransports",
  async (
    params: {
      page?: number;
      perPage?: number;
      tip_ruta?: number;
      masina?: string;
      ruta?: number;
      ruta_intranod?: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await apiRequest("/getTransportsRaports", "GET", params);
      return data;
    } catch (err: any) {
      console.warn("/transport/fetchActiveTransports", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const postEndActiveTransport = createAsyncThunk(
  "/transport/postEndActiveTransport",
  async (
    params: {
      page?: number;
      perPage?: number;
      idActiveTransport?: number | string;
      idSelectedReason?: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    const { page, perPage } = params;

    try {
      const { data } = await apiRequest(`/endActiveTransport`, "POST", params);
      dispatch(
        fetchActiveTransports({
          page: page,
          perPage: perPage,
        }),
      );
      return data;
    } catch (err: any) {
      console.warn("/transport/postEndActiveTransport", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const fetchCopyDriverRoutes = createAsyncThunk(
  "/transport/fetchCopyDriverRoutes",
  async (params: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await apiRequest(`/copyDriverRoutes`, "POST", params);
      return data;
    } catch (err: any) {
      console.warn("/transport/fetchCopyDriverRoutes", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const fetchTransportHistory = createAsyncThunk(
  "/transport/fetchTransportHistory",
  async (
    params: TransportHistoryFilters & {
      page?: number;
      perPage?: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await apiRequest("/getTransportHistory", "GET", params);
      return data;
    } catch (err: any) {
      console.warn("/transport/fetchTransportHistory", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const fetchTransportHistoryReport = createAsyncThunk(
  "/transport/fetchTransportHistoryReport",
  async (params: TransportHistoryFilters, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await apiRequest(
        "/getTransportHistoryRaport",
        "GET",
        params,
        undefined,
        { responseType: "blob" },
      );
      return data;
    } catch (err: any) {
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);
